export const colors = {
  background: "#F3F1EE",
  textPrimary: "#25323E",
  textSecondary: "#5C6874",
  buttonPrimary: "#2E7876",
  buttonPrimaryText: "#F6F6F6",
  buttonSecondaryBg: "#F8F8F8",
  buttonSecondaryText: "#2E7876",
  buttonSecondaryBorder: "#2E7876",
} as const;

export const fonts = {
  displaySemibold: "Fraunces_600SemiBold",
  bodyRegular: "Inter_400Regular",
  bodyMedium: "Inter_500Medium",
  bodySemibold: "Inter_600SemiBold",
} as const;
